/**
 * Utility functions for handling blog data from markdown files
 */
import { parseFrontmatter } from './markdown';

// Function to load all blog posts
export const loadBlogPosts = async () => {
  try {
    // Get the list of blog posts from the index.json file
    const response = await fetch('/data/blog/index.json');
    if (!response.ok) {
      throw new Error('Failed to fetch blog index');
    }
    
    const blogIndex = await response.json();
    
    // Return the blog list from the index
    return blogIndex;
  } catch (error) {
    console.error('Error loading blog posts:', error);
    return [];
  }
};

// Function to get a blog post by slug
export const getBlogBySlug = async (slug) => {
  try {
    const contentResponse = await fetch(`/data/blog/${slug}.md`);
    
    if (!contentResponse.ok) {
      throw new Error(`Failed to fetch blog with slug ${slug}`);
    }
    
    const markdownText = await contentResponse.text();
    const { frontmatter, content } = parseFrontmatter(markdownText);
    
    return {
      slug,
      title: frontmatter.title || 'Untitled Post',
      date: frontmatter.date || new Date().toISOString().split('T')[0],
      author: frontmatter.author || 'Admin',
      excerpt: frontmatter.excerpt || 'No excerpt available',
      content: content,
      coverImage: frontmatter.coverImage || '',
      tags: frontmatter.tags || [],
    };
  } catch (error) {
    console.error(`Error loading blog with slug ${slug}:`, error);
    return null;
  }
};